import { Route, Routes, Navigate } from 'react-router-dom';
import AuthPage from './pages/AuthPage';
import Verify from './pages/Verify';
import AccountVerification from './pages/AccountVerification';
import Dashboard from './pages/Dashboard';
import Bookings from './pages/Bookings';
import Templates from './pages/Templates';
import BookingTemplates from './pages/BookingTemplates';
import Slots from './pages/Slots';
import Contacts from './pages/Contacts';
import BatchJobs from './pages/BatchJobs';
import Chat from './pages/Chat';
import Enquiry from './pages/Enquiry';
import UserBookingBlocks from './pages/UserBookingBlocks';
import Notifications from './pages/Notifications';
import CustomPushNotifications from './pages/CustomPushNotifications';
import Promotions from './pages/Promotions';
import Faq from './pages/Faq';
import Layout from './components/Layout';

import AnalyticsTracker from './components/AnalyticsTracker';
import ProtectedRoute from './components/ProtectedRoute';
import { NotificationProvider } from './context/NotificationContext';
import ForgotPassword from './pages/ForgotPassword';
import './App.css';

function App() {
  return (
    <>
      <AnalyticsTracker />
      <Routes>
      {/* Public routes */}
      <Route path="/login" element={<AuthPage />} />
      <Route path="/verify" element={<Verify />} />
      <Route path="/account-verification" element={<AccountVerification />} />
      
        <Route path="/forgot-password" element={<ForgotPassword />} />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <NotificationProvider>
              <Layout />
            </NotificationProvider>
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="bookings" element={<Bookings />} />
        <Route path="templates" element={<Templates />} />
        <Route path="booking-templates" element={<BookingTemplates />} />
        <Route path="slots" element={<Slots />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="chat" element={<Chat />} />
        <Route path="enquiry" element={<Enquiry />} />
        <Route path="user-booking-blocks" element={<UserBookingBlocks />} />
        <Route path="batch-jobs" element={<BatchJobs />} />
        <Route path="promotions" element={<Promotions />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="custom-push-notifications" element={<CustomPushNotifications />} />
        <Route path="faq" element={<Faq />} />

      </Route>
      
      {/* Redirect root to dashboard */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      
      {/* fallback redirect */}
      <Route path="*" element={<AuthPage />} />
    </Routes>
    </>
  );
}

export default App;
